/**
 * 还差一个文本hover提示
 */

import React from 'react';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';

import { useIntl, history } from 'umi';
import { TABLE_METRICS_KEYS, TABLE_METRIC_COLUMNS_KEYS } from '../../constants';
import { addFormatMessageSafelyHandler } from '../../utils';

const DEFAULT_WIDTH = 0;
const DEFAULT_ALIGN = 'right';

interface MetricsHeaderItf {
  title: string;
  simpleTitle: string;
  sortKey: string;
  defaultSortKey: string;
  defaultSortOrder: 'desc' | 'asc';
  width?: number | string;
  isDodHide: boolean;
  onSortChange: Function;
}

export default function MetricsHeader(props: MetricsHeaderItf) {
  const { title, simpleTitle, sortKey, defaultSortKey, defaultSortOrder, width = DEFAULT_WIDTH, isDodHide, onSortChange } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const formatMessageSafely = addFormatMessageSafelyHandler(formatMessage);

  const simpleTitleTranslateKey = TABLE_METRICS_KEYS[simpleTitle];
  const titleTranslateKey = TABLE_METRIC_COLUMNS_KEYS[title];
  const translatedTitle = titleTranslateKey ? formatMessageSafely({ id: titleTranslateKey }) : title;
  const translatedSimpleTitle = simpleTitleTranslateKey ? formatMessageSafely({ id: simpleTitleTranslateKey }) : simpleTitle;

  const getSortList = () => {
    const titleTmp = translatedSimpleTitle || translatedTitle;
    const _list = [
      {
        key: `${sortKey}_0`,
        text: titleTmp,
        title: translatedTitle,
        ratioType: 0,
      },
    ];
    if (!isDodHide) {
      _list.push({
        key: `${sortKey}_1`,
        text: `${titleTmp}:${formatMessage({ id: 'dbi_change' })}(%)`,
        title: `${translatedTitle}(%)`,
        ratioType: 1,
      });
    }
    return _list;
  };

  return (
    <CloumsCenter width={width} align={DEFAULT_ALIGN}>
      <SortBy
        key={sortKey}
        title={translatedTitle}
        defaultKey={defaultSortKey}
        defaultValue={defaultSortOrder}
        list={getSortList()}
        onChange={onSortChange}
      />
    </CloumsCenter>
  );
}
